import type { FilterRuleEntity, OperationOption } from '../types'

import { Operators } from '../constants'

export const numericOnly = /[^0-9.-]/gi

export const toOperationValueOption = (t: OperationOption) => ({
	value: t.operation!,
	label: t.label!,
})

export const stringToArray = (value: string | string[]): string[] =>
	value ? (Array.isArray(value) ? value : value.split(',')) : []

export const arrayToString = (value: string[] | string): string =>
	value ? (Array.isArray(value) ? value.join(',') : value) : ''

export const isReferenceRule = (
	rule: FilterRuleEntity
): rule is FilterRuleEntity & { reference: string } =>
	Object.hasOwn(rule, 'reference')

export const isArrayOperation = (operation: Operators) =>
	[
		Operators.IN,
		Operators.NOT_IN,
		Operators.ALL_OF,
		Operators.ANY_OF,
		Operators.EXACT,
		Operators.NONE_OF,
	].includes(operation)

export const isBooleanOperation = (operation: Operators) =>
	[Operators.IS_EMPTY, Operators.IS_NOT_EMPTY].includes(operation)

export const isObject = (o: any) =>
	typeof o === 'object' && o !== null && !Array.isArray(o)

type X = Record<string, any>

type CloneObjOptions = { add?: X; remove?: string }
export const cloneObj = (obj: X, options: CloneObjOptions = {}) => {
	const { add, remove } = options
	// add key/value pair
	if (add) {
		return { ...obj, ...add }
	}

	// remove by key
	if (remove) {
		const n = { ...obj }
		delete n[remove]

		return n
	}

	return { ...obj }
}

export const objectMap = (object: X, mapFn: (a: any, b: string) => any) =>
	Object.keys(object).reduce((res, key) => {
		const result = cloneObj(res)
		const value = mapFn(object[key], key)

		if (value) {
			result[key] = value

			return result
		}

		return res
	}, {})

export const getUTCDate = (date: Date) =>
	new Date(
		date.getUTCFullYear(),
		date.getUTCMonth(),
		date.getUTCDate(),
		date.getUTCHours(),
		date.getUTCMinutes(),
		date.getUTCSeconds()
	)
